export default __webpack_public_path__ + "static/media/bscBUSD.488237bc.svg";